import { render, staticRenderFns } from "./collateral-info.vue?vue&type=template&id=2e20b6bc&"
import script from "./collateral-info.vue?vue&type=script&lang=ts&"
export * from "./collateral-info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports